export const CARD_GRID_MODULE_TEST_ID = {
  singleCard: 'single-card',
  carouselLayout: 'card-module-carousel-layout',
};
